import React from "react";
import { WhatsappIcon } from "./icons/WhatsappIcon";
import InstagramIcon from "./icons/InstagramIcon";
import { FacebookIcon } from "./icons/Facebook";

const FloatingSocialIcons = () => {
  return (
    <div className="fixed top-[75%] right-0 transform -translate-y-1/2 z-50 -mr-2 opacity-80 md:opacity-100">
      <div className="bg-gray-900 p-1 sm:p-2 rounded-xl shadow-lg flex flex-col items-center gap-1">
        {/* WhatsApp */}
        <a
          href="https://wa.me/905326036152"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-green-500 hover:bg-green-600 transition p-2 sm:p-3 rounded-full flex items-center justify-center"
          aria-label="WhatsApp"
        >
          <WhatsappIcon className="w-5 h-5 sm:w-6 sm:h-6" />
        </a>
        <p className="hidden md:block text-[10px] sm:text-xs text-white">WhatsApp</p>

        {/* Instagram */}
        <a
          href="https://instagram.com/ayvalikmarin"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-pink-500 hover:bg-red-600 transition p-2 sm:p-3 rounded-full flex items-center justify-center"
          aria-label="Instagram"
        >
          <InstagramIcon className="w-5 h-5 sm:w-6 sm:h-6" />
        </a>
        <p className="hidden md:block text-[10px] sm:text-xs text-white">Instagram</p>

        {/* Facebook */}
        <a
          href="https://facebook.com/ayvalikmarin"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-blue-500 hover:bg-blue-600 transition p-2 sm:p-3 rounded-full flex items-center justify-center"
          aria-label="Facebook"
        >
          <FacebookIcon className="w-5 h-5 sm:w-6 sm:h-6" />
        </a>
        <p className="hidden md:block text-[10px] sm:text-xs text-white">Facebook</p>
      </div>
    </div>
  );
};

export default FloatingSocialIcons;
